/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { List, Set as ImmutableSet } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import { AdAccountErrorStates, IGNORABLE_ACCOUNT_ERRORS_FOR_REPORTING as IGNORABLE_ACCOUNT_ERRORS } from 'AdsUI/records/ad-accounts/AdAccountRecord';
import ConnectAccountsFooter from 'AdsUI/components/pql/ConnectAccountsFooter';
import AdAccountSelectItemLabel from './AdAccountSelectItemLabel';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel'; // UISelect options must have string keys in the "value" field or there will be propTypes errors.

const getStringKeyForAdAccount = account => `${account.network}-${account.accountId}`;

class AdAccountSelect extends PureComponent {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  getOptions(connectedUsers) {
    const {
      maxAccounts,
      accountFilter,
      ignorableAccountErrors
    } = this.props;
    const reachedMax = maxAccounts ? accountFilter.size >= maxAccounts : false;
    return this.props.adAccounts.toArray().map(account => {
      const errorState = account.getErrorState(connectedUsers);
      const visibleErrorState = (ignorableAccountErrors || IGNORABLE_ACCOUNT_ERRORS).includes(errorState) ? AdAccountErrorStates.NONE : errorState;
      return {
        account,
        reachedMax,
        checked: accountFilter.has(account),
        onChangeAdAccount: this.onChangeAdAccount.bind(this, account),
        text: account.getDisplayName(),
        // Used only for searching
        value: getStringKeyForAdAccount(account),
        showCheckbox: true,
        errorState: visibleErrorState,
        disablePaymentMissingAccount: this.props.disablePaymentMissingAccount || false
      };
    });
  }

  onChange({
    target: {
      value
    }
  }) {
    // Most of the time this function won't run, and instead the onChangeAdAccount will.
    // However, it is relevant in the "very many ad accounts" case due to some behavior differences
    // that occur when the searchbox is present, and keyboard controls work. When the item is clicked,
    // the UICheckbox will route everything to onChangeAdAccount.
    const {
      adAccounts,
      maxAccounts,
      onFilterChange
    } = this.props;

    if (typeof value === 'string') {
      this.onChangeAdAccount(adAccounts.find(account => getStringKeyForAdAccount(account) === value));
      return;
    }

    const selectedAdAccounts = value.map(stringKey => adAccounts.find(account => getStringKeyForAdAccount(account) === stringKey)).filter(adAccount => adAccount.accessibleToPrimaryUser);

    if (!maxAccounts || selectedAdAccounts.length <= maxAccounts) {
      onFilterChange(ImmutableSet(selectedAdAccounts));
    }
  }

  onChangeAdAccount(account) {
    const {
      accountFilter,
      onFilterChange
    } = this.props;

    if (accountFilter.has(account)) {
      onFilterChange(accountFilter.delete(account));
    } else {
      onFilterChange(accountFilter.add(account));
    }
  }

  getButton() {
    const {
      adAccounts,
      accountFilter
    } = this.props;
    const count = adAccounts ? adAccounts.filter(adAccount => !!accountFilter.find(({
      accountId,
      network
    }) => adAccount.accountId === accountId && adAccount.network === network)).size : 0;
    const buttonText = count === 1 ? adAccounts.filter(adAccount => !!accountFilter.find(({
      accountId,
      network
    }) => adAccount.accountId === accountId && adAccount.network === network)).map(account => account.getDisplayName()).get(0) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "adAccountFilter.accountFilterText",
      options: {
        count
      }
    });
    return () => buttonText;
  }

  render() {
    const {
      accountFilter,
      maxAccounts,
      connectedUsers,
      customFooterNote
    } = this.props;
    const selectedAdAccounts = accountFilter.map(account => getStringKeyForAdAccount(account)).toArray();
    return /*#__PURE__*/_jsx(UIInlineLabel, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "adAccountFilter.accountFilterLabel"
      }),
      children: /*#__PURE__*/_jsx(UISelect, {
        "data-test-id": "account-select-label",
        ButtonContent: this.getButton(),
        className: "p-right-2 p-y-0",
        multi: maxAccounts !== 1,
        value: selectedAdAccounts,
        placement: "bottom right",
        anchorType: "button",
        buttonUse: "link",
        options: this.getOptions(connectedUsers),
        onChange: this.onChange,
        optionComponent: AdAccountSelectItemLabel,
        dropdownFooter: /*#__PURE__*/_jsx(ConnectAccountsFooter, {
          footerNote: customFooterNote
        }),
        menuWidth: 500
      })
    });
  }

}

AdAccountSelect.propTypes = {
  adAccounts: PropTypes.instanceOf(List).isRequired,
  accountFilter: PropTypes.instanceOf(ImmutableSet).isRequired,
  onFilterChange: PropTypes.func.isRequired,
  maxAccounts: PropTypes.number,
  ignorableAccountErrors: PropTypes.array,
  customFooterNote: PropTypes.node
};
export default AdAccountSelect;